import type { StateCreator } from 'zustand';
import type { GuidedDoctorConsultsActions, GuidedDoctorConsultsSliceType } from '../types';

export const setFieldsState: StateCreator<
  GuidedDoctorConsultsSliceType,
  [['zustand/immer', never], ['zustand/devtools', never]],
  [],
  GuidedDoctorConsultsActions['setFieldsState']
> = (set) => {
  return (fieldName, value) => {
    set(
      (state) => {
        state.guidedDoctorConsult.fields[fieldName] = value;
      },
      false,
      'guidedDoctorConsult/setFieldsState'
    );
  };
};
